import React from 'react';
import DocsDetailsSection from '../../Components/DocsDetails/docsdetails';
import FooterSection from '../../Components/Footer/footer';
import NavBar from '../../Components/NavBar/navbar';

export default function DocsPage() {
    return (
        <>
            <NavBar />
            <DocsDetailsSection />
            <FooterSection />
        </>
    );
}
